<template>
    <div class="content" style="padding:0;">

        <div class="card-header">
            <div class="row">


                <div class="col-xl-3 col-lg-5 col-md-6 col-sm-12 mb-2">
                    <label>{{$t("realEstate.field.evaluator")}}</label>
                    <v-select v-model="filter.employee" label="name"
                              :options="employes"
                              :filterable="false"
                              @search:focus="onEmployeFocus">
                        <template slot="option" slot-scope="option" v-if="option && option.name">
                            <div v-html="option.name"></div>
                        </template>
                        <template slot="selected-option"
                                  v-if="filter && filter.employee && filter.employee.name">
                            <div v-html="filter.employee.name"></div>
                        </template>
                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                    </v-select>
                </div>

                <div class="col-xl-3 col-lg-3 col-sm-6 mb-2">
                    <label>{{$t("report.date.startDate")}}</label>
                    <datepicker
                            class="form-control"
                            format="dd/MM/yyyy"
                            v-model="filter.startDate"
                            :clear-button="true"
                    ></datepicker>
                </div>

                <div class="col-xl-3 col-lg-3 col-sm-6 mb-2">
                    <label>{{$t("report.date.endDate")}}</label>
                    <datepicker
                            class="form-control"
                            format="dd/MM/yyyy"
                            v-model="filter.endDate"
                            :clear-button="true"
                    ></datepicker>
                </div>

                <div class="col-sm-1">
                    <label style="align-self: center">{{$t("main.search")}}</label>
                    <button class="all-btn form-control m-0" @click="initList"
                            style="color: #fff;background-color: #00bcd4;border-color: #00bcd4;
                                        box-shadow: 0 2px 2px 0 rgba(0, 188, 212, .14),
                                        0 3px 1px -2px rgba(0, 188, 212, .2),
                                        0 1px 5px 0 rgba(0, 188, 212, .12)">
                        <i class="fa fa-search"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="box">
            <vue-scrolling-table
                    :scroll-horizontal="scrollHorizontal"
                    :scroll-vertical="scrollVertical"
                    :sync-header-scroll="syncHeaderScroll"
                    :sync-footer-scroll="syncFooterScroll"
                    :include-footer="includeFooter"
                    :dead-area-color="deadAreaColor"
                    :class="{ freezeFirstColumn:freezeFirstColumn }">
                <template slot="thead" class="table-head">
                    <tr>
                        <th colspan="10"></th>
                        <th colspan="2">
                            {{$t("accounting.account.invoice")}}
                        </th>
                        <th colspan="2">
                            {{$t("report.field.car")}}
                        </th>
                        <th colspan="2">
                            {{$t("report.field.fitment")}}
                        </th>
                        <th colspan="2">
                            {{$t("report.field.building")}}
                        </th>
                        <th colspan="2">
                            {{$t("report.field.payment")}}
                        </th>
                        <th colspan="1"> </th>
                    </tr>
                    <tr>
                        <th v-for="col in columns"
                            :class="col.cssClasses"
                            :key="col.id">{{ col.title }}
                        </th>
                    </tr>
                </template>
                <template slot="tbody">
                    <tr v-for="item in items" :key="item.id">
                        <td v-for="col in columns"
                            :class="col.cssClasses"
                            :key="col.id">{{ item[col.id] }}
                        </td>
                    </tr>
                </template>
                <template slot="tfoot">
                    <tr>
                        <th :colspan="columns.length">{{totals}}</th>
                    </tr>
                </template>
            </vue-scrolling-table>
        </div>
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    import VueScrollingTable from "vue-scrolling-table"
    import initFilterModel from '@/shared/filter';
    import {formatDate, parseDate} from '@/shared/utils';
    // export const
    export default {
        name: "ReportAppraisersCapacity",
        components: {
            VueScrollingTable,
            Datepicker,
        },
        data: function () {
            return {
                loading: false,
                filter: initFilterModel(),
                scrollVertical: true,
                scrollHorizontal: true,
                syncHeaderScroll: true,
                syncFooterScroll: true,
                includeFooter: true,
                deadAreaColor: "#DDDDDD",
                maxRows: 10000,
                totals: 0,
                freezeFirstColumn: false,
                employes: [],
                provinces: [],

                columns: [
                    {id: "id", title: this.$t("main.number"), cssClasses: "col-auto"},
                    {id: "evaluationObjectId", title: this.$t("report.field.objectNumber"), cssClasses: "col-auto"},
                    {id: "employeName", title: this.$t("report.field.fullName"), cssClasses: "col-auto"},
                    {id: "provinceName", title: this.$t("report.field.province"), cssClasses: "col-auto"},
                    {id: "regionName", title: this.$t("report.field.district"), cssClasses: "col-auto"},
                    {id: "clientName", title: this.$t("report.field.organization"), cssClasses: "col-auto"},
                    {id: "debtorName", title: this.$t("report.field.ownerClient"), cssClasses: "col-auto"},
                    {id: "name", title: this.$t("report.field.name"), cssClasses: "col-auto"},
                    {id: "autoGovernmentNum", title: this.$t("report.field.governmentNum"), cssClasses: "col-auto"},
                    {id: "goalType", title: this.$t("report.field.evaluationPurpose"), cssClasses: "col-auto"},
                    {id: "numberContract", title: this.$t("accounting.account.number"), cssClasses: "col-auto"},
                    {id: "date", title: this.$t("accounting.account.date"), cssClasses: "col-auto"},
                    {id: "autoQty", title: this.$t("report.field.quantity"), cssClasses: "col-auto"},
                    {id: "autoPrice", title: this.$t("report.field.evaluationPrice"), cssClasses: "col-auto"},
                    {id: "fitmentQty", title: this.$t("report.field.quantity"), cssClasses: "col-auto"},
                    {id: "fitmentPrice", title: this.$t("report.field.evaluationPrice"), cssClasses: "col-auto"},
                    {id: "buildingQty", title: this.$t("report.field.quantity"), cssClasses: ""},
                    {id: "buildingPrice", title: this.$t("report.field.evaluationPrice"), cssClasses: ""},
                    {id: "paid", title: this.$t("report.field.paid"), cssClasses: ""},
                    {id: "unpaid", title: this.$t("report.field.unpaid"), cssClasses: ""},
                    {id: "spentTime", title: this.$t("report.field.spentTime"), cssClasses: ""},
                ],

                allItems: [],
            }
        },


        methods: {
            initList() {
                this.loading = true;
                this.init();
                this.filter.startDate = formatDate(this.filter.startDate);
                this.filter.endDate = formatDate(this.filter.endDate);
                this.filter.startDate = parseDate(this.filter.startDate);
                this.filter.endDate = parseDate(this.filter.endDate);
                this.$http.post('/report/list/appraisers', this.filter)
                    .then(res => {
                        this.allItems = res.data.data;
                        console.log(this.allItems);
                        this.totals = res.data.total;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            init() {
                const vm = this;
                const promises = [
                    this.$http.get('province/init')
                ];
                Promise.all(promises).then(function (values) {
                    const initData = values[0].data;
                    vm.provinces = initData.provinces;
                });
            },
            onEmployeFocus() {
                this.employes = [];
                this.filter.search = '';
                this.$http.post('employes/search', this.filter)
                    .then(res => {
                        this.employes = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
        },

        created() {
            this.initList();
        },


        computed: {
            items() {
                return this.allItems.slice(0, this.maxRows)
            },
        },
    }
</script>
<style>
    table.scrolling .w2 {
        width: 20em;
        min-width: 20em;
        max-width: 20em;
    }

    table.scrolling tfoot tr th {
        width: 130em;
        min-width: 130em;
        max-width: 130em;
        border-spacing: 0;
        border-collapse: collapse;
    }

    table.freezeFirstColumn thead tr,
    table.freezeFirstColumn tbody tr {
        display: block;
        width: min-content;
    }

    table.freezeFirstColumn thead td:first-child,
    table.freezeFirstColumn tbody td:first-child,
    table.freezeFirstColumn thead th:first-child,
    table.freezeFirstColumn tbody th:first-child {
        position: sticky;
        position: -webkit-sticky;
        left: 0;
    }

    * {
        font-family: sans-serif;
    }

    .box {
        clear: both;
        padding: 0;
        min-height: 740px;
        height: 40vh;
        margin-left: auto;
        margin-right: auto;
        overflow: hidden;
    }

</style>

